import { Overflow, OverflowItem, Tab, TabList } from "@fluentui/react-components";
import { useAtom } from "jotai";
import { devices } from "library/constants";
import { EBenefitContentTab, ITabProps } from "library/types";
import { useTranslation } from "react-i18next";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import styled from "styled-components";

import { OverflowMenuComponent } from "components/OverflowMenuComponent/OverflowMenuComponent";
import { useIsMobile } from "hooks/useIsMobile";

import { FilterContent } from "./FilterContent/FilterContent";

const tabs: ITabProps[] = [
  {
    id: EBenefitContentTab.all,
    name: "hbh.all.label",
    // icon: <GiftOpenRegular />,
  },
  {
    id: EBenefitContentTab.enrolled,
    name: "hbh.enrolled.label",
    // icon: <GiftOpenRegular />,
  },
  {
    id: EBenefitContentTab.eligible,
    name: "hbh.eligible.label",
    // icon: <GiftRegular />,
  },
  {
    id: EBenefitContentTab.expired,
    name: "hbh.expired.label",
    // icon: <GiftRegular />,
  },
];

export const ContentSelection = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const [selectedContentTab, setSelectedContentTab] = useAtom(benefitContentTabAtom);

  const onTabSelect = (tab) => {
    setSelectedContentTab(tab);
  };

  return (
    <Container>
      <Overflow minimumVisible={isMobile ? 4 : 7}>
        <TabList
          data-help="benefits-content-tabs"
          selectedValue={selectedContentTab}
          onTabSelect={(_, d) => onTabSelect(d.value as EBenefitContentTab)}
        >
          {tabs.map((tab) => {
            return (
              <OverflowItem
                key={tab.id}
                id={tab.id}
                priority={tab.id === selectedContentTab ? 2 : 1}
              >
                <StyledTab value={tab.id} icon={tab?.icon ? <span>{tab?.icon} </span> : null}>
                  {t(tab.name)}
                </StyledTab>
              </OverflowItem>
            );
          })}
          <OverflowMenuComponent tabs={tabs} onTabSelect={onTabSelect} />
        </TabList>
      </Overflow>
      <FilterContent />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.neutralLight};
`;

const StyledTab = styled(Tab)`
  @media only screen and ${devices.md} {
    padding: 10px 20px;
  }
`;
